<template>

  <div class="t-titlebg" :class="fixTop ? 't-fixTop' : ''">
    <div class="t-tieleBgBox" :style="{ opacity: opacity }"></div>
    <div class="t-titleBox">
      <div class="t-titleL">
        <img class="t-logo" :style="{ opacity: 1 - opacity }" src="../assets/img/tablogo.png" alt="" @click="clickHome" />
        <img class="t-logo1" :style="{ opacity: opacity }" src="../assets/img/cp1-logo.svg" alt="" @click="clickHome" />
        <div :class="[
          't-el-dropdown-link',
          curPath == '/ProductService' ? 't-el-dropdown-linkA' : '',
        ]" @click="productServiceClick">
          {{ contList.title[contType][0] }}
        </div>
        <el-dropdown placement="bottom-start" @command="handleCommand">
          <div :class="[
          't-el-dropdown-link',
          (curPath == '/ReceiptOrder' || curPath == '/Collection' || curPath == '/Overlay') ? 't-el-dropdown-linkA' : '',
        ]">
            {{ contList.title[contType][1] }}
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">{{
              contList.title[contType][2]
            }}</el-dropdown-item>
            <el-dropdown-item command="b">{{
              contList.title[contType][3]
            }}</el-dropdown-item>
            <el-dropdown-item command="c">{{
              contList.title[contType][4]
            }}</el-dropdown-item>
            <el-dropdown-item command="vas">{{
              contList.title[contType][11]
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div :class="[
          't-el-dropdown-link',
          curPath == '/Safety' ? 't-el-dropdown-linkA' : '',
        ]" @click="clickSafety">
          {{ contList.title[contType][5] }}
        </div>
        <div :class="[
          't-el-dropdown-link',
          curPath == '/AboutUs' ? 't-el-dropdown-linkA' : '',
        ]" @click="aboutUsClick">
          {{ contList.title[contType][6] }}
        </div>
        <div :class="[
          't-el-dropdown-link',
          curPath == '/ContactUs' ? 't-el-dropdown-linkA' : '',
        ]" @click="clickContactUs">
          {{ contList.title[contType][7] }}
        </div>
      </div>
      <div class="t-titleR">
        <el-dropdown>
          <div class="t-dp">
            <img class="t-language" :src="contList.languageImgPC[contType]" alt="" />
            <div class="t-down">
              <i class="el-icon-arrow-down t-down-icon" style="color:#fff;" :style="{ opacity: 1 - opacity }"></i>
              <i class="el-icon-arrow-down t-down-icon" style="color:#000;" :style="{ opacity: opacity }"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="changeLanguage('z')" class="t-dp">
                <img class="t-language" src="../assets/img/country.svg" alt="" />
                <span>{{ contList.language.z }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="changeLanguage('f')" class="t-dp" style="margin-top: 5px;">
                <img class="t-language" src="../assets/img/fan.svg" alt="" />
                <span>{{ contList.language.f }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="changeLanguage('e')" class="t-dp" style="margin-top: 5px;">
                <img class="t-language" src="../assets/img/en.svg" alt="" />
                <span>{{ contList.language.e }}</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div v-if="!isShow" class="t-action">
          <img class="t-actionIcon" :style="{ opacity: 1 - opacity }" src="../assets/img/icon_align-right.svg" alt=""
            @click="clickShowList" />
          <img class="t-actionIcon" :style="{ opacity: opacity }" src="../assets/img/icon_align-right.png" alt=""
            @click="clickShowList" />
        </div>
        <img v-if="isShow" class="t-action" src="../assets/img/icon_x.svg" alt="" @click="clickHideList" />
        <!-- <img  class="action" :src="isShow ? '../assets/img/icon_x.svg' : '../assets/img/icon_align-right.svg'" alt="" @click="clickShowList"/> -->
        <!-- <div class="loginBtn">
              {{ contList.title[contType][8] }}
            </div> -->
      </div>
    </div>

    <div :class="['t-listBox', isShow ? '' : 't-listBox_none']">
      <div class="t-titleBox">
        <div class="t-titleL">
          <img class="t-logo" src="../assets/img/cp1-logo.svg" alt="" @click="clickHome" />
        </div>
        <div class="t-titleR">
          <img v-if="!isShow" class="t-action" src="../assets/img/icon_align-right.svg" alt="" @click="clickShowList" />
          <img v-if="isShow" class="t-action" src="../assets/img/icon_x.svg" alt="" @click="clickHideList" />
        </div>
      </div>

      <div class="t-listBox2">
        <div v-if="listType === 0" class="t-topBox">
          <div class="t-itemBox" @click="clickHome">{{ contList.title[contType][9] }}</div>
          <div class="t-itemBox" @click="productServiceClick">{{ contList.title[contType][0] }}</div>
          <div class="t-itemBox" @click="clickSolution(1)">{{ contList.title[contType][1] }}</div>
          <div class="t-itemBox" @click="clickSafety">{{ contList.title[contType][5] }}</div>
          <div class="t-itemBox" @click="aboutUsClick">{{ contList.title[contType][6] }}</div>
          <div class="t-itemBox" @click="clickContactUs">{{ contList.title[contType][7] }}</div>
        </div>
        <div v-if="listType === 1" class="t-topBox">
          <div class="t-backTitle" @click="clickSolution(0)">
            <img class="t-bakcIcon" src="../assets/img/icon_back.svg" alt="">
            <div>{{ contList.title[contType][1] }}</div>
          </div>
          <div class="t-itemBox" @click="handleCommand('a')">{{ contList.title[contType][2] }}</div>
          <div class="t-itemBox" @click="handleCommand('b')">{{ contList.title[contType][3] }}</div>
          <div class="t-itemBox" @click="handleCommand('c')">{{ contList.title[contType][4] }}</div>
          <div class="t-itemBox" @click="handleCommand('vas')">{{ contList.title[contType][11] }}</div>
        </div>
        <div v-if="listType === 2" class="t-topBox">
          <div class="t-backTitle" @click="clickSolution(0)">
            <img class="t-bakcIcon" src="../assets/img/icon_back.svg" alt="">
            <div>{{ contList.title[contType][10] }}</div>
          </div>
          <div class="t-itemBox" @click="changeLanguage('z')">
            <img class="t-languageIcon margR16" src="../assets/img/country.svg" alt="">
            <div>{{ contList.languageList.z }}</div>
          </div>
          <div class="t-itemBox" @click="changeLanguage('f')">
            <img class="t-languageIcon margR16" src="../assets/img/fan.svg" alt="">
            <div>{{ contList.languageList.f }}</div>
          </div>
          <div class="t-itemBox" @click="changeLanguage('e')">
            <img class="t-languageIcon margR16" src="../assets/img/en.svg" alt="">
            {{ contList.languageList.e }}
          </div>
        </div>
        <div v-if="listType === 0" class="t-bottomBox" @click="clickSolution(2)">
          <div class="t-bottomBoxL">
            <img v-if="contType == 'z'" class="t-languageIcon" src="../assets/img/country.svg" alt="">
            <img v-if="contType == 'f'" class="t-languageIcon" src="../assets/img/fan.svg" alt="">
            <img v-if="contType == 'e'" class="t-languageIcon" src="../assets/img/en.svg" alt="">
            <div>{{ contList.language[contType] }}</div>
          </div>
          <img class="t-bottomBoxR" src="../assets/img/chevron-up.svg" alt="">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  data: (vm) => {
    return {
      fixTop: false,
      contList: {
        title: {
          z: [
            "产品服务",
            "解决方案",
            "独立站收单解决方案",
            "平台收款解决方案",
            "其他覆盖行业",
            "安全保障",
            "关于我们",
            "联系我们",
            "登录",
            "首页",
            "选择语言",
            "增值服务"
          ],
          f: [
            "產品服務",
            "解決方案",
            "獨立站收單解決方案",
            "平台收款解決方案",
            "其他覆蓋行業",
            "安全保障",
            "關於我們",
            "聯繫我們",
            "登錄",
            "首頁",
            "選擇語言",
            "增值服務"
          ],
          e: [
            "Products",
            "Solutions",
            "E-Commerce Websites",
            "E-Commerce Platform",
            "Other Industries",
            "Compliance",
            "About us",
            "Contact us",
            "Register",
            "Home",
            "Choose language",
            "Value-added Service"
          ],
        },
        language: {
          z: "简体中文",
          f: "繁体中文",
          e: "English"
        },
        languageList: {
          z: "中国（简体中文）",
          f: "中國香港（繁体中文）",
          e: "United States(English)"
        },
        languageImgPC: {
          z: require("../assets/img/country.svg"),
          f: require("../assets/img/fan.svg"),
          e: require("../assets/img/en.svg"),
        }
      },
      contType: "z",
      productServiceCls: "",
      curPath: "",
      isShow: false,
      listType: 0,
      opacity: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
    var that = this;
    this.contType = window.localStorage.getItem("language");
    window.addEventListener("setItemEvent", function (e) {
      if (e.key == "language") {
        that.contType = e.newValue;
      }
    });
    this.changePath(this.$router.history.current.path);
  },
  methods: {
    changeLanguage(value) {
      this.listType = 0
      this.isShow = false
      //z简体  f繁体  e英文
      window.localStorage.setItem("language", value);
    },
    // 获取页面滚动距离
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.opacity = scrollTop / 100
      if (scrollTop > 30) {
        this.fixTop = true;
      } else {
        this.fixTop = false;
      }
    },
    handleCommand(command) {
      this.clickHideList()
      if (command === 'a') {
        this.$router.push("/ReceiptOrder");
      } else if (command === 'b') {
        this.$router.push("/Collection");
      } else if (command === 'vas') {
        this.$router.push("/ValueAddedService");
      } else {
        this.$router.push("/Overlay");
      }
    },
    clickHome() {
      this.clickHideList()
      this.$router.push("/");
    },
    productServiceClick() {
      this.clickHideList()
      this.$router.push("/ProductService");
    },
    clickSafety() {
      this.clickHideList()
      this.$router.push("/Safety");
    },
    clickContactUs() {
      this.clickHideList()
      this.$router.push("/ContactUs");
    },
    aboutUsClick() {
      this.clickHideList()
      this.$router.push("/AboutUs");
    },
    changePath(path) {
      this.curPath = path;
    },
    clickShowList() {
      this.isShow = true
    },
    clickHideList() {
      this.isShow = false
    },
    clickSolution(value) {
      this.listType = value
    }
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      this.changePath(newVal);
    },
  },
};
</script>

<style lang="less" scoped>
//响应式示例写法
@media screen and (max-width: 800px) {

  //手机尺寸
  .t-titlebg {
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
  }

  .t-tieleBgBox {
    position: fixed;
    top: 0;
    left: 0;
    // background: #fff;
    background: rgba(255, 255, 255, 1);
    height: 69px;
    width: 100%;
  }

  .t-fixTop {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 1);
    height: 69px;
    width: 100%;
  }

  .t-titleBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 69px;
  }

  .t-titleL {
    display: flex;
    align-items: center;
  }

  .t-logo {
    width: 134px;
    margin-right: 36.54px;
    position: relative;
    margin-left: 16px;
  }

  .t-logo1 {
    width: 134px;
    margin-right: 36.54px;
    position: absolute;
    left: 16px;
  }




  .t-el-dropdown-link {
    width: 96px;
    height: 36px;
    //background: #2B82E9;
    border-radius: 100px 100px 100px 100px;
    color: #fff;
    cursor: pointer;
    // display: flex;
    display: none;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

  /deep/ .el-dropdown-menu__item:hover {
    background: #fff !important;
  }

  .t-titleR {
    display: flex;
    align-items: center;
  }

  .t-dp {
    display: none;
  }

  .t-actionIcon {
    top: 0px;
    left: 0px;
    width: 24px;
    height: 24px;
    position: absolute;
  }

  .t-action {
    width: 24px;
    height: 24px;
    margin-right: 16px;
    position: relative;
  }

  .t-listBox {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    // box-sizing: border-box;
    // padding-top: 69px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.5s ease;
    animation-name: example;
    animation-duration: 0.5s;
    animation-iteration-count: 1;
  }

  .t-listBox2 {
    width: 100%;
    height: 100%;
    height: calc(100% - 69px);
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @keyframes example {
    0% {
      left: 100%;
    }

    100% {
      left: 0;
    }
  }

  .t-listBox_none {
    display: none;
  }

  .t-topBox {
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 16px;
  }

  .t-bottomBox {
    height: 77px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
  }

  .t-itemBox {
    width: 100%;
    height: 76px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
  }

  .t-bottomBoxL {
    display: flex;
    align-items: center;
  }

  .t-bottomBoxR {
    display: flex;
    align-items: center;
  }

  .t-languageIcon {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  .t-margR16 {
    margin-right: 16px;
  }

  .t-backTitle {
    display: flex;
    align-items: center;
    height: 60px;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .t-bakcIcon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

}

@media screen and (min-width: 801px) {

  //大于手机使用
  .t-titlebg {
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
  }

  .t-tieleBgBox {
    position: fixed;
    top: 0;
    left: 0;
    // background: #fff;
    background: rgba(255, 255, 255, 1);
    height: 90px;
    width: 100%;
  }

  .t-fixTop {
    position: fixed;
    top: 0;
    left: 0;
  }

  .t-titleBox {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 90px;
    position: relative;
  }

  .t-titleL {
    display: flex;
    align-items: center;
  }

  .t-logo {
    width: 200px;
    margin-right: 56px;
    position: relative;
    bottom: 2px;
    cursor: pointer;
  }

  .t-logo1 {
    width: 200px;
    margin-right: 56px;
    bottom: 2px;
    position: absolute;
    top: 16px;
    cursor: pointer;
  }

  .t-el-dropdown-link {
    // width: 96px;
    // height: 36px;
    //background: #2B82E9;
    border-radius: 100px 100px 100px 100px;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    margin-left: 16px;
    padding: 7px 16px;
  }

  .t-el-dropdown-linkA {
    background: #fff;
    color: #2b82e9;
  }

  .t-fixTop .t-el-dropdown-link {
    color: #333;
  }

  .t-fixTop .t-el-dropdown-linkA {
    background: #2b82e9;
    color: #fff;
  }

  .t-fixTop .el-icon-arrow-down {
    color: #333;
  }

  .t-fixTop .loginBtn {
    color: #333;
    border: 2px solid rgba(51, 51, 51, 0.5);
  }

  /deep/ .el-dropdown-menu__item:hover {
    background: #fff !important;
  }

  .t-titleR {
    display: flex;
    align-items: center;
  }

  .t-language {
    width: 28px;
    height: 28px;
    margin-right: 4px;
  }

  .t-el-icon-arrow-down {
    font-size: 18px;
    color: #fff;
  }

  .t-dp {
    display: flex;
    align-items: center;
    cursor: pointer;
    // width: 50px;
  }

  .t-down {
    position: relative;
    width: 20px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .t-down-icon {
    position: absolute;
  }

  .t-loginBtn {
    width: 70px;
    height: 36px;
    border-radius: 100px 100px 100px 100px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-left: 30px;
  }

  .t-action {
    display: none;
  }

  .t-listBox {
    display: none;
  }
}
</style>